import { render, staticRenderFns } from "./JoinMember.vue?vue&type=template&id=9a7a20b4&scoped=true&"
import script from "./JoinMember.vue?vue&type=script&lang=js&"
export * from "./JoinMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7a20b4",
  null
  
)

export default component.exports